<template>
    <v-content class="bg-content">
      <div class="about card-animate-2">
        <v-container grid-list-xl style="padding: 5px; top: 20px;">
          <v-layout row wrap>
            <v-flex sm2 xs4 md4 lg2>
              <v-card elevation="3" class="chart-content">
                <div class="chart-title">Low</div>
                <div class="chart-text">{{ this.dashboard.tasksLow }}</div>
              </v-card>
            </v-flex>
            <v-flex sm2 xs4 md4 lg2>
              <v-card elevation="3" class="chart-content">
                <div class="chart-title">Medium</div>
                <div class="chart-text">{{ this.dashboard.tasksMed }}</div>
              </v-card>
            </v-flex>
            <v-flex sm2 xs4 md4 lg2>
              <v-card elevation="3" class="chart-content">
                <div class="chart-title">High</div>
                <div class="chart-text">{{ this.dashboard.tasksHigh }}</div>
              </v-card>
            </v-flex>

            <v-flex sm2 xs4 md4 lg2>
              <v-card elevation="3" class="chart-content">
                <div class="chart-title">New</div>
                <div class="chart-text">{{ this.dashboard.tasksNew }}</div>
              </v-card>
            </v-flex>
            <v-flex sm2 xs4 md4 lg2>
              <v-card elevation="3" class="chart-content">
                <div class="chart-title">In Process</div>
                <div class="chart-text">{{ this.dashboard.tasksStarted }}</div>
              </v-card>
            </v-flex>
            <v-flex sm2 xs4 md4 lg2>
              <v-card elevation="3" class="chart-content">
                <div class="chart-title">Completed</div>
                <div class="chart-text">{{ this.dashboard.tasksCompleted }}</div>
              </v-card>
            </v-flex>
          </v-layout>
        </v-container>
      </div>

      <div class="card-animate-2">
        <v-container grid-list-xl style="padding: 10px; top:20px">
          <v-card dark class="theme-bg-card-2 card-animate-2">
            <v-app-bar
              color="rgba(12, 22, 27, 0.9)"
              max-height="75"
              height="75"
              elevation="3"
              dense
              dark
            >
              <v-toolbar-title>
                <v-avatar size="40">
                  <img src="@/assets/TaskIcon.png" />
                </v-avatar>
                Tasks
              </v-toolbar-title>

              <v-spacer></v-spacer>

              <div>
                <v-text-field
                  v-model="search"
                  append-icon="mdi-magnify"
                  label="Search"
                  single-line
                  hide-details
                  dense
                  outlined
                  class="mr-1"
                  v-on:change="searchTask"
                ></v-text-field>
              </div>

              <v-btn class="ma-2" outlined color="white" value="Go Back From Whence You Came!" onclick="history.back(-1)">
                <p class="btn-text">Previous</p>
              </v-btn>

              <v-btn elevation="2" outlined dark depressed color="white" @click="openForm">
                <p class="btn-text">Create</p>
              </v-btn>
            </v-app-bar>

            <v-data-table
              class="theme-bg-card-2"
              :loading="tableLoader"
              loading-text="Loading... Please wait"
              :headers="headers"
              :items="tasksList"
              :search="search"
              max-width="750"
              id="virtual-scroll-table"
              v-scroll:#virtual-scroll-table-2="onScroll"
            >
              <template v-slot:item.controls="props">
                <i class="fa fa-trash thrash" @click="deleteConfirmation(props.item)"></i>
                <i class="fa fa-pencil thrash" @click="editTask(props.item)" style="margin-left: 20px"></i>
              </template>
            </v-data-table>
          </v-card>
        </v-container>
      </div>
      <v-dialog v-model="showConfirmation" max-width="290">
        <v-card class="theme-bg-card-4">
          <v-card-title class="text-h5">
            Are you sure you want to delete this task?
          </v-card-title>

          <v-card-text :v-if="itemToBeDeleted._id"> Task: {{ itemToBeDeleted.taskName }} </v-card-text>

          <v-card-actions>
            <v-spacer></v-spacer>

            <v-btn color="green darken-1" text @click="showConfirmation = false">
              Disagree
            </v-btn>

            <v-btn color="green darken-1" text :loading="loading3" :disabled="loading3" @click="deleteTask()">
              Agree
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>

      <v-overlay :value="overlay" opacity="0.98" z-index="9">
        <v-card v-scroll.self="onScroll" style="background-color: rgba(48, 64, 87, 0.8)" class="overflow-y-auto popup-container theme-bg-card-3">
          <v-layout row wrap fluid>
            <v-flex xs12 sm12 md12>
              <v-list-item class="mb-margin">
                <v-list-item-content>
                  <v-form ref="taskform" lazy-validation aria-autocomplete="off">
                    <v-banner class="justify-center text-h5 font-weight-light" sticky>
                      <v-avatar size="70">
                        <img src="@/assets/TaskIcon.png" />
                      </v-avatar>
                      Tasks
                    </v-banner>

                    <h6 class="display-6 font-weight-thin">
                      General Task Information
                    </h6>

                    <v-row>
                      <v-text-field v-model="formFields.taskName" class="mg-lr14" label="Task" outlined required></v-text-field>
                    </v-row>

                    <v-row>
                      <v-select v-model="formFields.ownerOptions" class="mg-lr14" :items="ownerOptions" label="Task Creator" outlined></v-select>

                      <v-select v-model="formFields.priority" class="mg-lr14" :items="priority" label="Priority" outlined></v-select>

                      <v-select v-model="formFields.status" class="mg-lr14" :items="status" label="Status" outlined></v-select>
                      <h6 style=" margin: 12px; color: #000417;" class="font-weight-thin">Deadline</h6>
                      <input type="date" v-model="formFields.deadline" label="Deadline" class="date-picker" />
                    </v-row>

                    <v-row>
                      <v-textarea class="mg-lr14" v-model="formFields.taskDetails" label="Task Details" outlined required></v-textarea>
                    </v-row>

                    <h6 class="display-6 font-weight-thin">Follow-Up Details</h6>

                    <v-row>
                      <v-select v-model="formFields.taskOwner" class="mg-lr14" :items="taskOwner" label="Task Assignment" outlined></v-select>

                      <v-select v-model="formFields.status" class="mg-lr14" :items="status" label="Status" outlined></v-select>
                      <h6 style=" margin: 12px; color: #78b59c;" class="font-weight-thin">Completion</h6>
                      <input type="date" v-model="formFields.completion" label="Completion" class="date-picker" />
                    </v-row>

                    <v-card-actions>
                      <v-spacer></v-spacer>
                      <v-btn class="mg-lr14" color="red" outlined @click="resetForm()">Cancel</v-btn>
                      <v-btn class="mg-lr14 submit" color="green" v-if="!editForm" :loading="loading3" :disabled="loading3" outlined @click="submitForm"
                        >Save</v-btn
                      >
                      <v-btn class="mg-lr14" color="green" v-if="editForm" :loading="loading3" :disabled="loading3" outlined @click="updateTask">Update</v-btn>
                    </v-card-actions>
                  </v-form>
                </v-list-item-content>
              </v-list-item>
            </v-flex>
          </v-layout>
        </v-card>
      </v-overlay>
    </v-content>
</template>

<script>
export default {
  name: 'Tasks',
  components: {},
  data() {
    return {
      scrollInvoked: 0,
      ownerOptions: ['John Salinas', 'Danny Barlavi', 'David Barlavi', 'Amelia Lang', 'Chris Mags', 'Christina Vega', 'Dilan Diaz', 'Mel Dickson'],
      taskOwner: ['John Salinas', 'Danny Barlavi', 'David Barlavi', 'Amelia Lang', 'Chris Mags', 'Christina Vega', 'Dilan Diaz', 'Mel Dickson'],
      dashboard: {},
      status: ['New', 'Pending', 'Started', 'Complete'],
      priority: ['Low', 'Medium', 'High'],
      items: [],
      tasksList: [],
      searchKey: '',
      search: '',
      optionIndex: 0,
      itemToBeDeleted: '',
      loading3: false,
      isLoading: false,
      productLoader: false,
      editForm: false,
      showConfirmation: false,
      overlay: false,
      rows: 100,
      itemsPerPage: 10,
      currentField: 0,
      tableLoader: false,
      date: '',
      formFields: {
        taskName: '',
        priority: '',
        status: '',
        category: '',
        taskDetails: '',
        deadline: '',
        completion: '',
      },
      modal_date_picker: false,
      form_valid: true,
      headers: [
        {
          text: 'Task',
          value: 'taskName',
          align: 'center',
          sortable: false,
          divider: true,
        },
        { text: 'Priority', value: 'priority', align: 'center', divider: true },
        { text: 'Status', value: 'status', align: 'center', divider: true },
        { text: 'Deadline', value: 'deadline', align: 'center', divider: true },
        { text: 'Completion', value: 'completion', align: 'center', divider: true },
        {
          text: 'Details',
          value: 'taskDetails',
          align: 'center',
          divider: true,
        },
        {
          text: '',
          value: 'controls',
          align: 'center',
          sortable: true,
          divider: true,
        },
      ],
    };
  },

  mounted() {
    this.getDashboard();
    this.getTasksList();
    Event.$on('openForm', () => {
      // Event.$off();
      console.log('Starting form in ' + this.$route.path);
      if (this.$route.path !== '/tasks') {
        return;
      }
      this.readOutLoud('Please fill the following details');
      setTimeout(() => {
        this.readOutLoud('What is the task');
        this.startListining();
      }, 3000);
      this.overlay = true;
    });

    Event.$on('editFromRecord', (data) => {
      if (this.$route.path !== '/tasks') {
        return;
      }
      console.log(data.msg);
      this.editTask(this.tasksList[0]);
    });

    Event.$on('searchFromRecord', (data) => {
      if (this.$route.path !== '/tasks') {
        return;
      }
      this.search = data.msg;
      this.searchTask(data.msg);
    });

    Event.$on('formDetails', (data) => {
      console.log(data);

      switch (data.msg) {
        case 'next':
          this.currentField++;
          this.navigateField();

          break;
        case 'previous':
          this.currentField--;
          this.navigateField();

          break;
        case 'submit':
          this.readOutLoud('Please verify your details');
          break;
        case 'verified':
          this.overlay = false;
          this.submitForm();
          break;
        default:
          this.fillForm(data.msg);
          break;
      }
    });
  },
  printLead: function() {
    window.print();
  },

  methods: {
    initialize() {
      this.tasksList = [];
    },
    getDashboard: async function() {
      const rawResponse = await fetch(`${process.env.VUE_APP_NODE_SERVER}analytics/all`);
      const content = await rawResponse.json();
      this.dashboard = content.response;
      console.log(content);
    },
    onScroll() {
      this.scrollInvoked++;
    },

    searchTask: async function() {
      console.log(this.search);
      if (!this.search) this.getTasksList();

      this.isLoading = true;
      const response = await fetch(`${process.env.VUE_APP_NODE_SERVER}task-form/search`, {
        method: 'POST',
        body: JSON.stringify({ searchText: this.search }), // string or object
        headers: {
          Accept: 'application/json',
          'Content-Type': 'application/json',
        },
      });
      const json = await response.json();
      this.isLoading = false;

      console.log(json);
      this.tasksList = json.result;
    },

    getTasksList: async function() {
      this.tableLoader = true;
      const response = await fetch(`${process.env.VUE_APP_NODE_SERVER}task-form/all`);
      const json = await response.json();
      console.log(json);
      this.tasksList = json.result;
      this.tableLoader = false;
    },

    submitForm: async function() {
      console.log(this.formFields);
      // console.log(this.inputs[0])

      this.loading3 = true;
      const response = await fetch(`${process.env.VUE_APP_NODE_SERVER}task-form/create`, {
        method: 'POST',
        body: JSON.stringify({ ...this.formFields }), // string or object
        headers: {
          Accept: 'application/json',
          'Content-Type': 'application/json',
        },
      });
      const json = await response.json(); //extract JSON from the http response
      console.log(json[0]);

      setTimeout(() => {
        this.readOutLoud('Task Created');
        this.getTasksList();
        this.resetForm();
      }, 800);
    },

    deleteConfirmation: function(item) {
      this.itemToBeDeleted = item;
      this.showConfirmation = true;
    },

    deleteTask: async function() {
      this.loading3 = true;
      const response = await fetch(`${process.env.VUE_APP_NODE_SERVER}task-form/delete`, {
        method: 'POST',
        body: JSON.stringify({ id: this.itemToBeDeleted._id }), // string or object
        headers: {
          Accept: 'application/json',
          'Content-Type': 'application/json',
        },
      });
      const json = await response.json(); //extract JSON from the http response
      console.log(json[0]);
      this.itemToBeDeleted = '';
      this.showConfirmation = false;
      this.loading3 = false;

      setTimeout(() => {
        this.readOutLoud('1 record deleted');
        this.getTasksList();
      }, 800);
    },

    editTask: function(data) {
      this.overlay = true;
      this.editForm = true;
      this.formFields = data;
    },

    updateTask: async function() {
      this.loading3 = true;

      const response = await fetch(`${process.env.VUE_APP_NODE_SERVER}task-form/update`, {
        method: 'POST',
        body: JSON.stringify(this.formFields), // string or object
        headers: {
          Accept: 'application/json',
          'Content-Type': 'application/json',
        },
      });
      const json = await response.json(); //extract JSON from the http response
      console.log(json[0]);

      setTimeout(() => {
        this.readOutLoud('1 record updated');
        this.getTasksList();
        this.resetForm();
      }, 800);
    },

    resetForm: function() {
      this.overlay = false;
      this.editForm = false;
      this.loading3 = false;
      this.formFields = {
        taskName: '',
        priority: '',
        status: '',
        category: '',
        taskDetails: '',
        deadline: '',
        completion: '',
      };
    },

    openForm: function() {
      this.overlay = true;
      this.items = [];
    },

    startListining: function() {
      setTimeout(() => {
        Event.$emit('speakModeOn');
      }, 1250);
    },

    beforeDestroy() {
      Event.$off('speakModeOn');
      Event.$off('openForm');
      Event.$off('searchFromRecord');
      Event.$off('editFromRecord');
    },

    readOutLoud: (msg) => {
      const speech = new SpeechSynthesisUtterance();
      const voiceName = 'Google UK English Male';
      speech.volume = 1;
      speech.rate = 1;
      speech.pitch = 1;
      speech.voice = speechSynthesis.getVoices().filter(function (voice) {
      return voice.name === voiceName
    })[0]
      speech.text = msg;
      window.speechSynthesis.speak(speech);

     speech.onend = function() {
      setTimeout(() => {
      Event.$emit('speakModeOn');
      }, 3200);
     };
    },
    
    dateCommand: function(msg) {
      let date;
      var currentDate = new Date(new Date().getTime() + 24 * 60 * 60 * 1000);
      var day = currentDate.getDate();
      var month = currentDate.getMonth() + 1;
      if (month < 9) {
        month = '0' + month;
      }
      var year = currentDate.getFullYear();
      switch (msg) {
        case 'today':
          date = new Date().toISOString().slice(0, 10);
          break;
        case 'tomorrow':
          date = year + '-' + month + '-' + (day + 1);
          break;
        default:
          msg = msg + ' ' + year;
          date = new Date(msg).toISOString().slice(0, 10);
          console.log(date);
          break;
      }

      return date;
    },

    fillForm: function(msg) {
      let firstChar = msg.charAt(0).toUpperCase();
      switch (this.currentField) {
        case 0:
          this.formFields.taskName = msg;
          break;
        case 1:
          this.formFields.priority = this.priority.filter((obj) => obj.indexOf(firstChar) != -1)[0];
          break;
        case 2:
          this.formFields.status = this.status.filter((obj) => obj.indexOf(firstChar) != -1)[0];
          break;
        case 3:
          this.formFields.deadline = this.dateCommand(msg);
          break;
        case 4:
          this.formFields.completion = this.dateCommand(msg);
          break;
        case 5:
          this.formFields.taskDetails = msg;
          break;
      }

      this.currentField++;
      this.navigateField();
    },

    navigateField: function() {
      console.log(this.currentField);
      switch (this.currentField) {
        case 0:
          this.readOutLoud('Task Name?');
          break;
        case 1:
          this.readOutLoud('Priority?');
          break;
        case 2:
          this.readOutLoud('Status?');
          break;
        case 3:
          this.readOutLoud('Deadline?');
          break;
        case 4:
          this.readOutLoud('Completion?');
          break;
        case 5:
          this.readOutLoud('Task Details?');
          break;
      }

      this.startListining();
    },
  },
};
</script>

<style scoped src="../components/css/Style.css">
@import '../components/css/Style.css';
</style>